/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Item_Query_LoggerInputs */

const en_dev_item_query_logger = /** @type {(inputs: Dev_Item_Query_LoggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Query Logger`)
};

const ar_dev_item_query_logger = /** @type {(inputs: Dev_Item_Query_LoggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الاستعلامات`)
};

const bn_dev_item_query_logger = /** @type {(inputs: Dev_Item_Query_LoggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কুয়েরি লগার`)
};

const de_dev_item_query_logger = /** @type {(inputs: Dev_Item_Query_LoggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abfrage-Logger`)
};

const es_dev_item_query_logger = /** @type {(inputs: Dev_Item_Query_LoggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrador de consultas`)
};

const fr_dev_item_query_logger = /** @type {(inputs: Dev_Item_Query_LoggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistreur de requêtes`)
};

const pt_dev_item_query_logger = /** @type {(inputs: Dev_Item_Query_LoggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrador de consultas`)
};

const zh_dev_item_query_logger = /** @type {(inputs: Dev_Item_Query_LoggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查询记录器`)
};

const tr_dev_item_query_logger = /** @type {(inputs: Dev_Item_Query_LoggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorgu Kaydedici`)
};

const ru_dev_item_query_logger = /** @type {(inputs: Dev_Item_Query_LoggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регистратор запросов`)
};

const pl_dev_item_query_logger = /** @type {(inputs: Dev_Item_Query_LoggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejestrator zapytań`)
};

/**
* | output |
* | --- |
* | "Query Logger" |
*
* @param {Dev_Item_Query_LoggerInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_item_query_logger = /** @type {((inputs?: Dev_Item_Query_LoggerInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Item_Query_LoggerInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_item_query_logger(inputs)
	if (locale === "bn") return bn_dev_item_query_logger(inputs)
	if (locale === "de") return de_dev_item_query_logger(inputs)
	if (locale === "es") return es_dev_item_query_logger(inputs)
	if (locale === "fr") return fr_dev_item_query_logger(inputs)
	if (locale === "pt") return pt_dev_item_query_logger(inputs)
	if (locale === "zh") return zh_dev_item_query_logger(inputs)
	if (locale === "tr") return tr_dev_item_query_logger(inputs)
	if (locale === "ru") return ru_dev_item_query_logger(inputs)
	if (locale === "pl") return pl_dev_item_query_logger(inputs)
	return en_dev_item_query_logger(inputs)
});